var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: 'Dynamic flag answers change each time the lab is started.',
    placement: 'top-center',
    classes: ['dynamic-flag__tooltip'],
  }),expression:"{\n    content: 'Dynamic flag answers change each time the lab is started.',\n    placement: 'top-center',\n    classes: ['dynamic-flag__tooltip'],\n  }"}],staticClass:"dynamic-flag"},[_vm._v("\n  Dynamic Flag\n  "),_c('AlertCircleIcon',{attrs:{"size":"16"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }